export default class DeletePersonalConvocatoria {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idPersonal, idConvocatoriaPersonal) {
    try {
      const result = await this.#repository.deletePersonalConvocatoria(idPersonal, idConvocatoriaPersonal)
      return result
    } catch (error) {
      console.error('Error al eliminar la asignación de personal a convocatoria:', error)
      throw error
    }
  }
}
